import { useQueryClient } from '@tanstack/react-query'
import { defer } from 'lodash'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToDynamicHashElement = () => {
  const location = useLocation()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!location.hash) return

    const unsubscribe = queryClient.getQueryCache().subscribe((cache) => {
      if (cache.query.state?.status === 'success') {
        const element: HTMLElement | null = document.querySelector(
          location.hash
        )

        if (element) {
          defer(() => {
            element.scrollIntoView({
              behavior: 'auto',
              block: 'start',
              inline: 'nearest'
            })
          })

          unsubscribe()
        }
      }
    })

    return () => {
      unsubscribe()
    }
  }, [queryClient, location.hash])

  return null
}

export default ScrollToDynamicHashElement
